import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SkuService } from 'src/app/services/sku.service';


@Component({
  selector: 'app-sku-planta',
  templateUrl: './sku-planta.component.html',
  styleUrls: ['./sku-planta.component.scss']
})
export class SkuPlantaComponent implements OnInit {

  sku_planta: string = '';
  planta: string = '';
  id: any;
  isEdit: boolean = false;
  searchQuery  : string = "";
  plantaSearchList : Array<any> = [];


  constructor(
      public dialogRef: MatDialogRef<SkuPlantaComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private skuService: SkuService,
      private router: Router,
  ) {}

  ngOnInit(): void {
    if (this.data) {
      this.sku_planta = this.data.sku_planta;
      this.planta = this.data.planta;
      this.id = this.data.id;
      this.isEdit = true;
    }
  }

  agregarSKU(){
    
    this.dialogRef.close({
      sku_planta: this.sku_planta,
      planta: this.planta,
      id: this.id
    });
    
  }

  doSearch(evento : any){
    const inputValue = (evento.target as HTMLInputElement).value;
    this.searchQuery = inputValue;

    this.plantaSearchList = [];
    
    if(inputValue.trim()!= ''){
      this.skuService.searchPlanta(inputValue).subscribe((x: any) => {
      
        this.plantaSearchList = x.data;
  
      },
      (err:any) => {
           // this.main.HideLoading();
          }
      );
    }

  }

  onResultSelection(planta: string){
   
      this.searchQuery = planta;
      this.plantaSearchList = [];

  }

}
